module.exports = __webpack_public_path__ + "img/productBgImg17.ea6a1ef2.png";